import useStore from './useStore';

const useAuthStore = () => {
    const { authStore } = useStore();

    return authStore;
};

export default useAuthStore;
